import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { humanReadableByteCount } from './../../lib/helper'
import BVUpsellBanner from './../bvupsellbanner'
import DefaultBanner from './../defaultbanner'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class Stats extends React.Component {
	render() {
		const { migrate, canUpsell, progress, progressMessage } = this.props
		return <span>
			<div className="clearfix" style={{height: "30px"}}></div>
			<div className="row">
				{ canUpsell ? <BVUpsellBanner /> : <DefaultBanner /> }
			</div>
			<div className="col-xs-9 col-md-9 center-dom">
				<div className="row">
					<div className="clearfix" style={{height: "30px"}}></div>
					<p style={{ float: "left", paddingTop: "0.6rem", fontSize: "1.6rem" }}>
						Migrating <strong style={{ color: "#249182" }}>{ migrate.get('source_site') }</strong> to <strong style={{ color: "#249182" }}>{ migrate.get('destination_site') }</strong>
					</p>
					<div className="bv-plan-details-container bv-mig-details-container">
						<div className="col-xs-6 col-md-6">
							<div className="col-xs-6 col-md-6 pull-left text-left">
								<p className="bv-plan-title" style={{ color: "inherit" }}>
									{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'synced'])) }/{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'total']) - migrate.getIn(['status', 'files', 'size', 'ignored'])) } Files
								</p>
							</div>
							<div className="col-xs-12 col-md-12 pull-left text-left">
								<ProgressBar now={ migrate.getIn(['status', 'files_progress']) }/>
							</div>
						</div>
						<div className="col-xs-6 col-md-6">
							<div className="col-xs-6 col-md-6 pull-left text-left mig-stat-desc">
								<p className="bv-plan-title" style={{ color: "inherit" }}>
									{ migrate.getIn(['status', 'database', 'synced']) }/{ migrate.getIn(['status', 'database', 'total']) - migrate.getIn(['status', 'database', 'ignored']) } Tables
								</p>
							</div>
							<div className="col-xs-12 col-md-12 pull-left text-left mig-stat-desc">
								<ProgressBar bsStyle="success" now={ migrate.getIn(['status', 'tables_progress']) } />
							</div>
						</div>
						<div className="col-xs-12 col-md-12">
							<div className="col-xs-6 col-md-6 pull-left text-left mig-stat-desc" style={{marginTop: "2rem"}}>
								<p className="bv-plan-title" style={{ color: "inherit" }}>Migrating Site ({progressMessage()})</p>
							</div>
							<div className="col-xs-12 col-md-12 pull-left text-left mig-stat-desc">
								<ProgressBar bsStyle="info" now={progress}/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</span>
	}
}

Stats.propTypes = {
	task: ImmutablePropTypes.map,
	canUpsell: PropTypes.bool,
	cancel: PropTypes.func,
	migrate: ImmutablePropTypes.map,
	progressMessage: PropTypes.func,
	progress: PropTypes.number 
}

export default Stats
